import React, { useEffect, useRef } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import s from './s.module.less';

interface InvoicePaidSuccessToastProps {
    visible: boolean;
    onClose: () => void;
}

const InvoicePaidSuccessToast: React.FC<InvoicePaidSuccessToastProps> = ({ visible, onClose }) => {
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (!visible) return;
        timerRef.current = setTimeout(onClose, 5000);
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [visible, onClose]);

    if (!visible) return null;

    const handleClose = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        onClose();
    };

    return (
        <div className={s.toastWrap}>
            <span className={s.text}>Invoice paid successfully</span>
            <button
                type="button"
                className={s.closeBtn}
                onClick={handleClose}
                aria-label="Close"
            >
                <CloseOutlined className={s.closeIcon} />
            </button>
        </div>
    );
};

export default InvoicePaidSuccessToast;
